const SecurityModals = {
    LoadExtension: 'LoadExtension',
    BatchLoadExtensions: 'BatchLoadExtensions',
    Fetch: 'Fetch',
    OpenWindow: 'OpenWindow',
    Redirect: 'Redirect',
    RecordAudio: 'RecordAudio',
    RecordVideo: 'RecordVideo',
    ReadClipboard: 'ReadClipboard',
    Notify: 'Notify',
    Geolocate: 'Geolocate',
    Embed: 'Embed',
    Download: 'Download',
    CustomPermission: 'CustomPermission'
};

export default SecurityModals;
